import { useContext, useState } from "react";
import Button from "../../../components/Button";
import Grid from "../../../components/Grid";
import Input from "../../../components/Input/inputs";
import Cache from "../../../services/cache";
import { AuthContext } from "../../../services/context";
import * as utils from "../../../services/utilities";
import Recipient from "../detail";
const cache = new Cache();

export default function Find({ survey }) {
  // utils.log.component(`Recipient.Find(surveyCode: ${survey.code})`, survey);
  // #region Assertions
  utils.assert(survey != null, "Survey required.  Unable to find recipient.");
  // #endregion
  // #region Initialize
  const { recipientService } = useContext(AuthContext);
  const [recipient, setRecipient] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //const [uid, setUid] = useState(null);

  //const searchFields = ["UID", "Occupation"];
  // #endregion
  // #region Events

  const handleFind = async () => {
    try {
      if (cache.get("uid") != null && survey.code != null && !recipient) {
        setIsLoading(true);
        const recipient = await recipientService.getByUid(
          cache.get("uid"),
          survey.code
        );
        if (typeof recipient === "object" && recipient?.status === 200) {
          setRecipient(recipient);
          cache.setDetails(recipient);
        } else {
          setRecipient(null);
        }
      }
    } catch (error) {
      utils.log.error(error);
    } finally {
      setIsClicked(true);

      setIsLoading(false);
    }
  };
  // #endregion

  return (
    /*     <Dialog open={open} onClose={onClose}>
      <DialogTitle>Find Recipient</DialogTitle>
      <DialogContent>
        <DialogContentText>Find recipient instructions</DialogContentText> */

    <Grid container spacing={2}>
      {/*           <Grid item xs={12}>
            <WorksiteSelector
              worksiteCode={worksiteCode}
              setWorksiteCode={setWorksiteCode}
            />
          </Grid> */}

      <Grid item xs={12} sm={10} className="reactTour30Step">
        <Input
          label="UID"
          fullWidth
          name="uid"
          onChange={(e) => cache.set("uid", e.target.value)}
          defaultValue={() => cache.get("uid")}
        ></Input>
      </Grid>
      <Grid item xs={12} sm={2} container justifyContent={"flex-end"}>
        <Button
          variant="contained-primary"
          onClick={handleFind}
          style={{
            borderRadius: "4px",
            padding: "13.5px 40px",
            marginBottom: "20px",
          }}
        >
          Find
        </Button>
      </Grid>
      {isLoading ? (
        <div
          style={{
            paddingLeft: "16px",
            display: "flex",
            justifyContent: "center ",
            alignItems: "center",
          }}
        >
          Loading...
        </div>
      ) : recipient ? (
        // <Grid item container spacing={2}>
        <div style={{ paddingLeft: "16px" }}>
          <Recipient
            surveyCode={survey.code}
            uid={cache.get("uid")}
            recipient={recipient}
          ></Recipient>
          {/* </Grid> */}
        </div>
      ) : (
        isClicked &&
        !recipient && (
          <p
            style={{
              paddingLeft: "16px",
              color: "#FC1818",
              lineHeight: "24px",
              fontWeight: "500",
            }}
          >
            UID not found !!
          </p>
        )
      )}
    </Grid>
    /*         <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </DialogContent>
    </Dialog> */
  );
}
